import {
  Component,
  forwardRef
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import { InputBaseComponent } from '../base/base.component';

@Component({
  selector: 'jb-input-password',
  templateUrl: './password.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputPasswordComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => InputPasswordComponent),
      multi: true
    }
  ]
})
export class InputPasswordComponent extends InputBaseComponent {
  protected type: string = 'password';
}



// WEBPACK FOOTER //
// ./src/app/form/input/password/password.component.ts